import svg from '../js/svg';
import U from '../js/utils';
import comp from '../components/barrel';

const EXCLUDED_AGES = [18, 21, 25];
const OTHER_AGE_TEXT = 'other age';
const TRUST_CHOICE_INHERITANCE = 'Inheritance of minors in trust';
const TRUST_CHOICE_NONE = 'No trust required';
const TRUST_CHOICE_OPTIONS = [TRUST_CHOICE_INHERITANCE, TRUST_CHOICE_NONE];
const EP_MARK_TRUST_NOT_NEEDED = 'application/mark-trust-not-needed';

export default {
  application_uuid: null,
  trustDetail: null,
  coExecList: [],
  trusteeList: [],
  trustNotNeededMarked: false,
  async prepare() {
    this.application_uuid = thsPage.vars.application_uuid;
    const vars = {};
    vars.application_uuid = this.application_uuid;
    this.recipe.methods.push(await O.mPOST('application/get-trust-detail2', vars));
    this.recipe.methods.push(await O.mPOST('application/get-trustee-list', vars));
    this.recipe.methods.push(await O.mPOST('application/get-coexecutor-list', vars));
  },
  async render() {
    const rec = this.recipe.methods;

    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },
  async loadPage(data) {
    this.trustDetail = data['application/get-trust-detail2']?.data || null;
    await this.buildTrustSection(this.trustDetail);

    const trusteeList = data['application/get-trustee-list']?.data || [];
    await this.buildTrusteeSection(trusteeList);

    const coExecList = data['application/get-coexecutor-list']?.data || [];
    await this.buildCoExecutorSection(coExecList);
    this.syncContinueBtn();
    setTimeout(() => this.attachTrustDetailsFormListeners(), 0);
  },
  attachTrustDetailsFormListeners() {
    const form = U.id('trustDetailsForm');
    if (!form || form.dataset.trustListenersAttached === '1') return;
    form.dataset.trustListenersAttached = '1';

    form.addEventListener('change', (event) => {
      const target = event.target;
      if (target?.name === 'inh_age') {
        this.onInheritanceAgeChange();
      } else if (target?.id === 'inh_guardian') {
        this.toggleAssetsCheckboxes('guardian');
        this.syncUpdateTrustDetailsBtn();
      } else if (target?.id === 'inh_trust') {
        this.toggleAssetsCheckboxes('trust');
        this.syncUpdateTrustDetailsBtn();
      }
    });

    form.addEventListener('input', (event) => {
      if (event.target?.id === 'inh_age_other') {
        this.syncUpdateTrustDetailsBtn();
      }
    });
  },
  onInheritanceAgeChange() {
    this.otherInhAge();
    this.syncUpdateTrustDetailsBtn();
  },
  getTrustChoice() {
    const selected = document.querySelector('input[name="trust_choice"]:checked');
    return selected ? selected.value : null;
  },
  isInheritanceTrustSelected() {
    return this.getTrustChoice() === TRUST_CHOICE_INHERITANCE;
  },
  hasTrustNotNeededMarked(trustData = this.trustDetail) {
    if (!trustData) return false;
    return (
      trustData.trust_not_needed_yn === true ||
      trustData.not_needed_yn === true ||
      trustData.trust_not_needed === true
    );
  },
  selectTrustChoice(value) {
    document.querySelectorAll('input[name="trust_choice"]').forEach((radio) => {
      radio.checked = radio.value === value;
    });
  },
  syncContinueBtn() {
    const btn = U.id('next-btn');
    if (!btn) return;

    const choice = this.getTrustChoice();
    if (!choice) {
      btn.disabled = true;
      return;
    }

    if (choice === TRUST_CHOICE_NONE) {
      btn.disabled = !this.trustNotNeededMarked;
      return;
    }

    btn.disabled = !this.hasActiveTrust();
  },
  toggleAccordion(contentId, arrowId) {
    const contentDiv = U.id(contentId);
    const arrow = U.id(arrowId);
    if (!contentDiv || !arrow) return;

    if (contentDiv.classList.contains('hide')) {
      U.unhide(contentId);
      arrow.classList.remove('arrowDown');
    } else {
      U.hide(contentId);
      arrow.classList.add('arrowDown');
    }
  },
  toggleTrusteeAddAccordion() {
    this.toggleAccordion('trusteeAdd_content', 'trusteeAdd_arrow');
  },
  toggleCoExecAddAccordion() {
    this.toggleAccordion('coExecAdd_content', 'coExecAdd_arrow');
  },
  async fetchTrustDetail() {
    const res = await O.PREP([
      await O.mPOST('application/get-trust-detail2', { application_uuid: this.application_uuid }),
    ]);
    this.trustDetail = res['application/get-trust-detail2']?.data || null;
    return this.trustDetail;
  },
  hasActiveTrust() {
    return Boolean(this.trustDetail?.application_trust_uuid);
  },
  syncTrusteeSectionVisibility() {
    const section = U.id('trusteeSection');
    if (!section) return;
    section.classList.toggle('hide', !this.isInheritanceTrustSelected());
  },
  async buildTrustSection(trustData) {
    const card = U.id('trust_section');
    if (!card) return;

    card.innerHTML = '';

    const hasTrust = Boolean(trustData?.application_trust_uuid);
    const trustNotNeeded = !hasTrust && this.hasTrustNotNeededMarked(trustData);
    this.trustNotNeededMarked = trustNotNeeded;

    const trustChoiceRadio = await comp.inputRadio('trust_choice', TRUST_CHOICE_OPTIONS, 0);
    card.appendChild(trustChoiceRadio);

    if (hasTrust) {
      this.selectTrustChoice(TRUST_CHOICE_INHERITANCE);
    } else if (trustNotNeeded) {
      this.selectTrustChoice(TRUST_CHOICE_NONE);
    }

    document.querySelectorAll('input[name="trust_choice"]').forEach((radio) => {
      radio.setAttribute('onchange', 'thsSubTab.onTrustChoiceChange()');
    });

    const trustDetailsForm = U.divAtt('div', 'id', 'trustDetailsForm');
    trustDetailsForm.className = hasTrust ? 'mt-6' : 'mt-6 hide';

    const ageDiv = U.divAtt('div');
    const heading = document.createElement('h6');
    heading.innerHTML = 'Inheritance age';
    ageDiv.appendChild(heading);

    const optionsArr = ['18 years old', '21 years old', '25 years old', OTHER_AGE_TEXT];
    const inhAgeRadio = await comp.inputRadio('inh_age', optionsArr, 1);
    ageDiv.appendChild(inhAgeRadio);

    const inheritanceAge = trustData?.inheritance_age;
    const otherAge = EXCLUDED_AGES.includes(inheritanceAge) ? '' : inheritanceAge || '';

    const otherInhAge = await comp.inputNumber('inh_age_other', otherAge, 'Other inheritance age', 0);
    const otherInhAgeInput = otherInhAge.querySelector('#inh_age_other');
    if (otherInhAgeInput) {
      otherInhAgeInput.style.width = '6ch';
      otherInhAgeInput.style.maxWidth = '6ch';
    }
    ageDiv.appendChild(otherInhAge);
    trustDetailsForm.appendChild(ageDiv);

    const guardian = await comp.inputCheckbox(
      'inh_guardian',
      trustData?.assets_to_guardian_yn === true,
      'Movable assets to be kept by guardian'
    );
    trustDetailsForm.appendChild(guardian);

    const addedToTrust = await comp.inputCheckbox(
      'inh_trust',
      trustData?.assets_to_trust_yn === true,
      'Movable assets to be sold and value added to trust'
    );
    trustDetailsForm.appendChild(addedToTrust);

    const trustNotes = await comp.textarea('trust-notes', '', 'Notes', 0);
    trustDetailsForm.appendChild(trustNotes);

    const updateBtn = U.divAtt('button', 'class', 'btn mt-6');
    updateBtn.id = 'updateTrustDetailsBtn';
    updateBtn.innerHTML = 'Update trust details';
    updateBtn.disabled = true;
    updateBtn.setAttribute('onclick', 'thsSubTab.updateTrustDetails()');
    trustDetailsForm.appendChild(updateBtn);

    card.appendChild(trustDetailsForm);

    trustDetailsForm.querySelectorAll('input[name="inh_age"]').forEach((radio) => {
      radio.setAttribute('onchange', 'thsSubTab.onInheritanceAgeChange()');
    });

    U.id('inh_guardian')?.setAttribute(
      'onchange',
      'thsSubTab.toggleAssetsCheckboxes("guardian"); thsSubTab.syncUpdateTrustDetailsBtn();'
    );
    U.id('inh_trust')?.setAttribute(
      'onchange',
      'thsSubTab.toggleAssetsCheckboxes("trust"); thsSubTab.syncUpdateTrustDetailsBtn();'
    );

    U.id('inh_age_other')?.setAttribute('oninput', 'thsSubTab.syncUpdateTrustDetailsBtn()');

    this.applyInheritanceAgeToForm(inheritanceAge);
    this.applyTrustNotesToForm(trustData?.notes);
    this.syncUpdateTrustDetailsBtn();
    this.syncTrusteeSectionVisibility();
    this.syncContinueBtn();
  },
  canEnableUpdateTrustDetails() {
    return Boolean(this.getInheritanceAgeValue());
  },
  syncUpdateTrustDetailsBtn() {
    const btn = U.id('updateTrustDetailsBtn');
    if (!btn) return;
    btn.disabled = !this.canEnableUpdateTrustDetails();
  },
  applyInheritanceAgeToForm(inheritanceAge) {
    const form = U.id('trustDetailsForm');
    if (inheritanceAge == null) {
      U.hide('inh_age_otherDiv');
      return;
    }

    const ageValue = EXCLUDED_AGES.includes(inheritanceAge)
      ? `${inheritanceAge} years old`
      : OTHER_AGE_TEXT;
    const selectAge = form?.querySelector(`input[name="inh_age"][value="${ageValue}"]`);

    if (selectAge) {
      selectAge.checked = true;
    }

    const otherAgeInput = U.id('inh_age_other');
    if (ageValue === OTHER_AGE_TEXT && inheritanceAge) {
      U.unhide('inh_age_otherDiv');
      otherAgeInput?.setAttribute('required', '');
      if (otherAgeInput) otherAgeInput.value = inheritanceAge;
    } else {
      U.hide('inh_age_otherDiv');
      otherAgeInput?.removeAttribute('required');
    }
  },
  applyTrustNotesToForm(notes) {
    const notesEl = U.id('trust-notes');
    if (notesEl) {
      notesEl.value = notes ?? '';
    }
  },
  getInheritanceAgeValue() {
    const form = U.id('trustDetailsForm');
    const selected = form?.querySelector('input[name="inh_age"]:checked');
    if (!selected) {
      return null;
    }
    if (selected.value === OTHER_AGE_TEXT) {
      return U.id('inh_age_other')?.value?.trim() || null;
    }
    return selected.value.split(' ')[0];
  },
  async markTrustNotNeeded() {
    this.trustNotNeededMarked = false;
    this.syncContinueBtn();

    const body = {
      application_uuid: this.application_uuid,
      notes: null,
    };

    try {
      const res = await O.PREP([await O.mPOST(EP_MARK_TRUST_NOT_NEEDED, body)]);
      const result = res[EP_MARK_TRUST_NOT_NEEDED];
      const statusCode = res[`${EP_MARK_TRUST_NOT_NEEDED}_SC`];
      const isSuccess =
        (typeof statusCode === 'number' && statusCode >= 200 && statusCode < 300) ||
        result?.status === 'OK' ||
        result?.status === 'CREATED';

      if (isSuccess) {
        this.trustNotNeededMarked = true;
        comp.toast(result?.message || result?.status || 'Trust marked as not required');
        this.syncContinueBtn();
        return true;
      }

      this.selectTrustChoice('');
      comp.errorBox('Error', result?.message || 'Failed to mark trust as not required.');
      this.syncContinueBtn();
      return false;
    } catch (err) {
      this.selectTrustChoice('');
      comp.errorBox('Error', 'Failed to mark trust as not required. Please try again.');
      this.syncContinueBtn();
      return false;
    }
  },
  async onTrustChoiceChange() {
    const choice = this.getTrustChoice();

    if (choice === TRUST_CHOICE_INHERITANCE) {
      this.trustNotNeededMarked = false;
      U.unhide('trustDetailsForm');
      this.syncTrusteeSectionVisibility();
      this.syncContinueBtn();
      return;
    }

    if (choice !== TRUST_CHOICE_NONE) {
      this.syncContinueBtn();
      return;
    }

    if (this.hasActiveTrust()) {
      const confirmed = confirm('Remove this trust and its details?');
      if (!confirmed) {
        this.selectTrustChoice(TRUST_CHOICE_INHERITANCE);
        return;
      }

      try {
        await O.PREP([
          await O.mPOST('application/remove-trust', {
            application_trust_uuid: this.trustDetail.application_trust_uuid,
          }),
        ]);
        this.trustDetail = await this.fetchTrustDetail();
        await this.refreshTrusteeSection();
        comp.toast('Trust removed');
      } catch (err) {
        this.selectTrustChoice(TRUST_CHOICE_INHERITANCE);
        comp.errorBox('Error', 'Failed to remove trust. Please try again.');
        return;
      }
    }

    U.hide('trustDetailsForm');
    this.syncTrusteeSectionVisibility();
    await this.markTrustNotNeeded();
  },
  async updateTrustDetails() {
    if (!this.canEnableUpdateTrustDetails()) {
      return;
    }

    const inheritanceAge = this.getInheritanceAgeValue();

    const body = {
      application_uuid: this.application_uuid,
      inheritance_age: Number(inheritanceAge),
      assets_to_guardian_yn: U.id('inh_guardian')?.checked === true,
      assets_to_trust_yn: U.id('inh_trust')?.checked === true,
      notes: U.id('trust-notes')?.value?.trim() || null,
    };

    try {
      const res = await O.PREP([await O.mPOST('application/ups-trust-detail2', body)]);
      comp.toast(res['application/ups-trust-detail2']?.status || 'Trust details updated');
      this.trustDetail = await this.fetchTrustDetail();
      this.trustNotNeededMarked = false;
      this.selectTrustChoice(TRUST_CHOICE_INHERITANCE);
      this.applyInheritanceAgeToForm(this.trustDetail?.inheritance_age);
      if (U.id('inh_guardian')) {
        U.id('inh_guardian').checked = this.trustDetail?.assets_to_guardian_yn === true;
      }
      if (U.id('inh_trust')) {
        U.id('inh_trust').checked = this.trustDetail?.assets_to_trust_yn === true;
      }
      this.applyTrustNotesToForm(this.trustDetail?.notes);
      U.unhide('trustDetailsForm');
      this.syncTrusteeSectionVisibility();
      this.syncUpdateTrustDetailsBtn();
      this.syncContinueBtn();
    } catch (err) {
      comp.errorBox('Error', 'Failed to update trust details. Please try again.');
    }
  },
  otherInhAge() {
    const form = U.id('trustDetailsForm');
    const selected = form?.querySelector('input[name="inh_age"]:checked');
    if (!selected) {
      this.syncUpdateTrustDetailsBtn();
      return;
    }

    const otherAgeInput = U.id('inh_age_other');
    if (selected.value === OTHER_AGE_TEXT) {
      U.unhide('inh_age_otherDiv');
      otherAgeInput?.setAttribute('required', '');
    } else {
      U.hide('inh_age_otherDiv');
      otherAgeInput?.removeAttribute('required');
    }
    this.syncUpdateTrustDetailsBtn();
  },
  toggleAssetsCheckboxes(checkedType) {
    const guardianCheckbox = U.id('inh_guardian');
    const trustCheckbox = U.id('inh_trust');

    if (checkedType === 'guardian' && guardianCheckbox.checked) {
      trustCheckbox.checked = false;
    } else if (checkedType === 'trust' && trustCheckbox.checked) {
      guardianCheckbox.checked = false;
    }
  },
  async refreshTrusteeSection() {
    const refreshRes = await O.PREP([
      await O.mPOST('application/get-trustee-list', { application_uuid: this.application_uuid }),
    ]);
    const trusteeList = refreshRes['application/get-trustee-list']?.data || [];
    await this.buildTrusteeSection(trusteeList);
    this.syncTrusteeSectionVisibility();
  },
  getTrusteeDisplayName(row) {
    return `${row.f_name || row.fname || ''} ${row.s_name || row.sname || ''}`.trim();
  },
  async buildTrusteeSection(trusteeList = []) {
    const section = U.id('trusteeSection');
    if (!section) return;

    this.trusteeList = trusteeList;
    section.innerHTML = '';
    Object.keys(communal).length === 0 && (await U.getCommunalDropdowns());

    const heading = document.createElement('h6');
    heading.innerHTML = 'Trustees';
    section.appendChild(heading);

    if (trusteeList.length > 0) {
      const table = document.createElement('table');
      table.id = 'trusteeTable';
      table.className = 'mt-4 mb-8';
      const thead = document.createElement('thead');
      const headRow = thead.insertRow();
      ['Name', 'Relationship', 'Notes', 'Remove'].forEach((text) => {
        const th = document.createElement('th');
        th.innerHTML = text;
        headRow.appendChild(th);
      });
      table.appendChild(thead);

      const tbody = document.createElement('tbody');
      for (const row of trusteeList) {
        const dataRow = tbody.insertRow();
        const name = dataRow.insertCell(0);
        name.innerHTML = this.getTrusteeDisplayName(row);
        const rel = dataRow.insertCell(1);
        rel.innerHTML = row.relationship || '';
        const notes = dataRow.insertCell(2);
        notes.innerHTML = row.notes || '';
        const removeIcon = dataRow.insertCell(3);
        const onclick = `thsSubTab.removeTrustee('${row.application_trustee_uuid}')`;
        const linkSVG = svg.trash(onclick);
        removeIcon.appendChild(linkSVG);
      }
      table.appendChild(tbody);
      section.appendChild(table);
    }

    const formContainer = U.divAtt('div', 'id', 'trusteeFormContainer');
    const accordion = U.divAtt('div', 'class', 'card mb-8 mt-4');
    accordion.id = 'trusteeAddAccordion';

    const header = U.divAtt('div', 'class', 'flex justify-between cursor-pointer');
    header.setAttribute('onclick', 'thsSubTab.toggleTrusteeAddAccordion()');
    const accordionHeading = U.divAtt('h5');
    accordionHeading.innerHTML = 'Add trustee';
    const arrow = await svg.chevronUp('trusteeAdd_arrow');
    arrow.classList.add('arrowDown');
    header.appendChild(accordionHeading);
    header.appendChild(arrow);
    accordion.appendChild(header);

    const contentDiv = U.divAtt('div', 'id', 'trusteeAdd_content');
    contentDiv.classList.add('hide');
    contentDiv.appendChild(U.divAtt('hr', 'class', 'mb-8'));

    const formGrid = U.divAtt('div', 'class', 'res-grid-cols-2 mt-4');
    formGrid.id = 'trusteeForm';

    const f_name = await comp.inputText('trustee-f_name', '', 'Full names', 1);
    const s_name = await comp.inputText('trustee-s_name', '', 'Surname', 1);
    const IDpass = await comp.inputIDPassport('trustee-IDpass', true, '', 1);
    const relationship = await comp.selectRelationship('trustee-relationship', [], 1);
    const notes = await comp.textarea('trustee-textarea', '', 'Notes', 0);

    formGrid.appendChild(f_name);
    formGrid.appendChild(s_name);
    formGrid.appendChild(IDpass);
    formGrid.appendChild(relationship);
    formGrid.appendChild(notes);

    const addBtn = U.divAtt('button', 'class', 'btn mt-4');
    addBtn.innerHTML = 'Add Trustee';
    addBtn.setAttribute('onclick', 'thsSubTab.addTrustee()');

    contentDiv.appendChild(formGrid);
    contentDiv.appendChild(addBtn);
    accordion.appendChild(contentDiv);
    formContainer.appendChild(accordion);
    section.appendChild(formContainer);
  },
  clearTrusteeForm() {
    U.id('trustee-f_name') && (U.id('trustee-f_name').value = '');
    U.id('trustee-s_name') && (U.id('trustee-s_name').value = '');
    U.id('trustee-IDpass') && (U.id('trustee-IDpass').value = '');
    U.id('trustee-relationship') && (U.id('trustee-relationship').value = '');
    U.id('trustee-textarea') && (U.id('trustee-textarea').value = '');
  },
  async addTrustee() {
    if (!this.hasActiveTrust()) {
      comp.errorBox('Missing trust', 'Please update trust details before adding a trustee.');
      return;
    }

    const isValid = await U.validateForm('trusteeForm');
    if (!isValid) return;

    const idToggle = U.id('trustee-IDpass_toggle');
    const body = {
      application_uuid: this.application_uuid,
      f_name: U.id('trustee-f_name').value.trim(),
      s_name: U.id('trustee-s_name').value.trim(),
      id_nr: idToggle && idToggle.checked ? U.id('trustee-IDpass').value.trim() || null : null,
      passport_nr: idToggle && idToggle.checked ? null : U.id('trustee-IDpass').value.trim() || null,
      relationship_uuid: U.id('trustee-relationship').value || null,
      notes: U.id('trustee-textarea').value.trim() || null,
    };

    try {
      await O.PREP([await O.mPOST('application/ins-trustee', body)]);
      this.clearTrusteeForm();
      await this.refreshTrusteeSection();
      comp.toast('Trustee added');
    } catch (err) {
      comp.errorBox('Error', 'Failed to add trustee. Please try again.');
    }
  },
  async removeTrustee(application_trustee_uuid) {
    const row = this.trusteeList?.find((r) => r.application_trustee_uuid === application_trustee_uuid);
    const name = row ? this.getTrusteeDisplayName(row) || 'this trustee' : 'this trustee';
    const confirmed = confirm(`Are you sure you want to remove ${name} as trustee?`);

    if (!confirmed) return;

    try {
      const res = await O.PREP([
        await O.mPOST('application/rmv-trustee', { application_trustee_uuid }),
      ]);
      comp.toast(
        res['application/rmv-trustee']?.data?.message ||
          res['application/rmv-trustee']?.status ||
          'Trustee removed'
      );
      await this.refreshTrusteeSection();
    } catch (err) {
      comp.errorBox('Error', 'Failed to remove trustee. Please try again.');
    }
  },
  async buildCoExecutorSection(coExecList = []) {
    const section = U.id('coExecutorSection');
    if (!section) return;

    this.coExecList = coExecList;
    section.innerHTML = '';
    Object.keys(communal).length === 0 && (await U.getCommunalDropdowns());

    if (coExecList.length > 0) {
      const table = document.createElement('table');
      table.id = 'coExecTable';
      table.className = 'mt-10 mb-8';
      const thead = document.createElement('thead');
      const headRow = thead.insertRow();
      ['Name', 'Relationship', 'Notes', 'Active', 'Remove'].forEach((text) => {
        const th = document.createElement('th');
        th.innerHTML = text;
        headRow.appendChild(th);
      });
      table.appendChild(thead);

      const tbody = document.createElement('tbody');
      for (const row of coExecList) {
        const dataRow = tbody.insertRow();
        const name = dataRow.insertCell(0);
        name.innerHTML = `${row.fname || ''} ${row.sname || ''}`.trim();
        const rel = dataRow.insertCell(1);
        rel.innerHTML = row.relationship || '';
        const notes = dataRow.insertCell(2);
        notes.innerHTML = row.notes || '';
        const active = dataRow.insertCell(3);
        active.innerHTML = row.active_yn ? 'Yes' : 'No';
        const removeIcon = dataRow.insertCell(4);
        const onclick = `thsSubTab.removeCoExecutor(${row.d_application_coexecutor_id})`;
        const linkSVG = svg.trash(onclick);
        removeIcon.appendChild(linkSVG);
      }
      table.appendChild(tbody);
      section.appendChild(table);
    }

    const formContainer = U.divAtt('div', 'id', 'coExecFormContainer');
    const accordion = U.divAtt('div', 'class', 'card mb-8 mt-4');
    accordion.id = 'coExecAddAccordion';

    const header = U.divAtt('div', 'class', 'flex justify-between cursor-pointer');
    header.setAttribute('onclick', 'thsSubTab.toggleCoExecAddAccordion()');
    const accordionHeading = U.divAtt('h5');
    accordionHeading.innerHTML = 'Add co-executor';
    const arrow = await svg.chevronUp('coExecAdd_arrow');
    arrow.classList.add('arrowDown');
    header.appendChild(accordionHeading);
    header.appendChild(arrow);
    accordion.appendChild(header);

    const contentDiv = U.divAtt('div', 'id', 'coExecAdd_content');
    contentDiv.classList.add('hide');
    contentDiv.appendChild(U.divAtt('hr', 'class', 'mb-8'));

    const formGrid = U.divAtt('div', 'class', 'res-grid-cols-2 mt-4');
    formGrid.id = 'coExecForm';

    const f_name = await comp.inputText('coExec-f_name', '', 'Full names', 1);
    const s_name = await comp.inputText('coExec-s_name', '', 'Surname', 1);
    const IDpass = await comp.inputIDPassport('coExec-IDpass', true, '', 1, 'coExec-dob');
    const dob = await comp.inputDate('coExec-dob', '', 'Date of birth: ', 1);
    const relationship = await comp.selectRelationship('coExec-relationship', [], 1);
    const notes = await comp.textarea('coExec-textarea', '', 'Notes', 0);

    formGrid.appendChild(f_name);
    formGrid.appendChild(s_name);
    formGrid.appendChild(IDpass);
    formGrid.appendChild(dob);
    formGrid.appendChild(relationship);
    formGrid.appendChild(notes);

    const addBtn = U.divAtt('button', 'class', 'btn mt-4');
    addBtn.innerHTML = 'Add Co-executor';
    addBtn.setAttribute('onclick', 'thsSubTab.addCoExecutor()');

    contentDiv.appendChild(formGrid);
    contentDiv.appendChild(addBtn);
    accordion.appendChild(contentDiv);
    formContainer.appendChild(accordion);
    section.appendChild(formContainer);
  },
  clearCoExecForm() {
    U.id('coExec-f_name') && (U.id('coExec-f_name').value = '');
    U.id('coExec-s_name') && (U.id('coExec-s_name').value = '');
    U.id('coExec-IDpass') && (U.id('coExec-IDpass').value = '');
    U.id('coExec-dob') && (U.id('coExec-dob').value = '');
    U.id('coExec-relationship') && (U.id('coExec-relationship').value = '');
    U.id('coExec-textarea') && (U.id('coExec-textarea').value = '');
  },
  async addCoExecutor() {
    const isValid = await U.validateForm('coExecForm');
    if (!isValid) return;

    const idToggle = U.id('coExec-IDpass_toggle');
    const body = {
      application_uuid: this.application_uuid,
      f_name: U.id('coExec-f_name').value.trim(),
      s_name: U.id('coExec-s_name').value.trim(),
      id_nr: idToggle && idToggle.checked ? U.id('coExec-IDpass').value.trim() || null : null,
      passport_nr: idToggle && idToggle.checked ? null : U.id('coExec-IDpass').value.trim() || null,
      dob: U.id('coExec-dob').value || null,
      relationship_uuid: U.id('coExec-relationship').value || null,
      notes: U.id('coExec-textarea').value.trim() || null,
    };

    try {
      await O.PREP([await O.mPOST('application/ins-coexecutor', body)]);
      this.clearCoExecForm();
      const refreshRes = await O.PREP([
        await O.mPOST('application/get-coexecutor-list', { application_uuid: this.application_uuid }),
      ]);
      const coExecList = refreshRes['application/get-coexecutor-list']?.data || [];
      await this.buildCoExecutorSection(coExecList);
      comp.toast('Co-executor added');
    } catch (err) {
      comp.errorBox('Error', 'Failed to add co-executor. Please try again.');
    }
  },
  async removeCoExecutor(d_application_coexecutor_id) {
    const row = this.coExecList?.find((r) => r.d_application_coexecutor_id === d_application_coexecutor_id);
    const name = row ? `${row.fname || ''} ${row.sname || ''}`.trim() || 'this co-executor' : 'this co-executor';
    const confirmed = confirm(`Are you sure you want to remove ${name} as co-executor?`);

    if (!confirmed) return;

    try {
      const res = await O.PREP([await O.mPOST('application/rmv-coexecutor', { d_application_coexecutor_id })]);
      comp.toast(
        res['application/rmv-coexecutor']?.data?.message ||
          res['application/rmv-coexecutor']?.status ||
          'Co-executor removed'
      );
      const refreshRes = await O.PREP([
        await O.mPOST('application/get-coexecutor-list', { application_uuid: this.application_uuid }),
      ]);
      const coExecList = refreshRes['application/get-coexecutor-list']?.data || [];
      await this.buildCoExecutorSection(coExecList);
    } catch (err) {
      comp.errorBox('Error', 'Failed to remove co-executor. Please try again.');
    }
  },
  async savePage(nextPrev) {
    if (nextPrev === 'next_page') {
      const choice = this.getTrustChoice();
      if (!choice) {
        comp.errorBox(
          'Selection required',
          'Please choose whether inheritance in trust applies or no trust is required.'
        );
        return;
      }
      if (choice === TRUST_CHOICE_INHERITANCE && !this.hasActiveTrust()) {
        comp.errorBox('Missing trust details', 'Please update trust details before continuing.');
        return;
      }
      if (choice === TRUST_CHOICE_NONE && !this.trustNotNeededMarked) {
        comp.errorBox(
          'Confirmation required',
          'Please select "No trust required" and wait for confirmation before continuing.'
        );
        return;
      }
    }

    const method = 'application/val-app-page';
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.page_name = 'ADs_Trust';
    O.PREP([await O.mPOST(method, vars)])
      .then(async (res) => {
        comp.toast(res[method].status);
        thsPage.pageProgress(res[method].data, nextPrev);
      })
      .catch(() => {});
  },
};
